module.exports = __webpack_public_path__ + "static/media/vial.c93549a9.svg";